import script from "./SmartPhoneUnder.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartPhoneUnder.vue?vue&type=script&setup=true&lang=ts"

import "./SmartPhoneUnder.vue?vue&type=style&index=0&id=8638d958&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8638d958"]])

export default __exports__